import { Dispatch } from "redux"

import { IDLE, PENDING } from "const"
import { MtDriveFolder, MtDriveFolderCreate } from "server/models"
import { deepCopy } from "client/utils"
import {
    DRIVE_ACTION_RENAME,
    DriveFolder,
    UserData,
    LangType,

    CreateDriveFolder,

    createDriveUrl,
    setDriveAction,

    setDriveFolderListLoadState,
    setDriveFolderListEmpty,
    setDriveFolderList,
    setDriveFolderActive,
} from "client/store"

// eslint-disable-next-line import/prefer-default-export
export const AddFolder = (
    drivePath: readonly MtDriveFolder[],
    baseRoute: string,
    userData: UserData,
    folderList: readonly DriveFolder[],
    lang: LangType,
    dispatch: Dispatch,
) => {
    dispatch(setDriveFolderListLoadState(PENDING))

    const targetFolderId = drivePath.length ? drivePath[drivePath.length - 1].id : 0
    const newFolder: MtDriveFolderCreate = {
        folderId: targetFolderId,
        prevFolderId: null,
        accountId: userData.accountId,
        projectId: null,
        qidProductId: null,
        name: lang.newFolder,
        copy: 0,
    }

    CreateDriveFolder(newFolder, lang).then((res) => {
        if (res.newFolder) {
            const newDrivePath: MtDriveFolder[] = deepCopy(drivePath)
            newDrivePath.push(res.newFolder)

            const newDriveFolder: DriveFolder = {
                ...res.newFolder,
                url: createDriveUrl(newDrivePath, baseRoute),
                path: newDrivePath,
            }
            const newFolderList: DriveFolder[] = folderList ? deepCopy(folderList) : []
            newFolderList.unshift(newDriveFolder)

            dispatch(setDriveFolderList(newFolderList))
            dispatch(setDriveFolderActive(newDriveFolder))
            dispatch(setDriveFolderListEmpty(false))
            dispatch(setDriveAction(DRIVE_ACTION_RENAME))
        }
        dispatch(setDriveFolderListLoadState(IDLE))
    })
}
